import {
    AUTH_ERROR,
    AUTH_SUCCESS,
    ERROR_MESSAGE,
    LOADED,
    LOADING,
    SUCCESS_MESSAGE,
    VALIDATION_AUTH_ERROR,
    VALIDATION_ERROR,
} from './types';

import history from '../history';
import api from './apis';

// ==========================Register==============
export const GetRegister = (data) => async (dispatch) => {
  
  dispatch({type: LOADING});
  const company_detail = {
    name : data.company_name,
    mobile_number: data.company_mobile_number,
    email: data.company_email,

    address : {
        street_address : data.street_address,
        post_code : data.post_code,
        city: data.city
    }
  };
  const object = {
   
    first_name : data.first_name,
    last_name : data.last_name,
    mobile_number : data.mobile_number,
    email: data.email,
    client_type : data.client_type,

    company_detail,

    password : data.password,
    confirm_password : data.confirm_password,

    news_letter : data.news_letter,

    brand_name : data.brand_name
  };

  try {
    const response = await api().post(
      "/signup",
      { ...object }
    );

    if (response.status === 201) {
      
    dispatch({type: LOADED});
    dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
    history.push('/login')
    }
  } catch (err) {
    /* =============Start========== */
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      
      if(err.message == 'Network Error')
      {
          history.push('/maintenance')
          return
      }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
      dispatch({type: LOADED});
    /* ===========End============*/}
};


// ====================Login==================
export const login = (email, password) => async (dispatch) => {
    
    dispatch({type: LOADING});
    try{
        const response =  await api().post('/signin', {
            email: email, password: password},{
                headers: { 'content-type': 'application/json'}
            });
            if(response.data.active_account === false){
              
              history.push('/pending-verification')
            }
            if(response.status === 201 ){
                localStorage.setItem("token", response.data.token);
                try{

                  const res = await api(response.data.token).get(`/profile-detail`);
                  if(res.status === 200){
                    localStorage.setItem("brand", res.data.data.brand_name);
                    localStorage.setItem("dp", res.data.data.client_image);
                    localStorage.setItem("city", res.data.data.address?.city);
                    localStorage.setItem("post_code", res.data.data?.address?.post_code);
                    localStorage.setItem("street_address", res.data.data?.address?.street_address);
                  } 

                dispatch({type: LOADED})
                history.push('/')
                }
                catch(err){
                    if(err?.response?.status === 451 ){
                      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
                      history.push('/pending-verification')
                    }
                }
            }
        
    }catch(err){
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          if(err?.response?.status === 451 ){
              history.push('/pending-verification')
          }
          
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
      }

}

// =================Log out=====================
export const logOut = () => async (dispatch) => {
    dispatch({ type: LOADING});
    try{
        const response = await api(localStorage.getItem("token")).post("/signout");
        
        if(response.status === 201)
        {
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: AUTH_SUCCESS, payload: 'Successfully logout' });
        dispatch({ type: LOADED });

    }catch (err){

      
      if(err?.response?.status === 451 ){
        localStorage.clear();
        history.push('/login')
      }
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_AUTH_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: AUTH_ERROR, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: AUTH_ERROR, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }

  
// ========================Get Profile data==========================
export const getProfileById = (id) => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(
        `/user-management/user/detail?user=${id}`
      );
      
      dispatch({type: LOADED});
      return response.data.user
      
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };
  
  
// ========================Update Profile==========================
  export const updateProfile = (data) => async (dispatch) => {
    dispatch({type: LOADING});
    const personal_info = {
      date_of_birth: data.date_of_birth,
      gender: data.gender,
      permanent_address: data.permanent_address,
      present_address: data.present_address,
      emergency_number: data.emergency_number,
    };
    const object = {
      remark:data.remark,
      name: data.name,
      email: data.email,
      mobile_number: data.mobile_number,
      password: data.password,
      authenticated: true,
      user: data.user_id,
      role: data.role,
  
      personal_info,
    };
    dispatch({type: LOADED});
  
    try {
      const response = await api(localStorage.getItem("token")).patch("/user-management/user/update",{ ...object });
  
      if (response.status === 201) {
        
      dispatch({type: LOADED});
      dispatch({type: SUCCESS_MESSAGE,payload: "User is updated succesfully"});
      
      return response.status;
      }
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

  
    
// ===================Change Password=====================
export const updateOwnPassword = (data) => async (dispatch) => {
    dispatch({type: LOADING});
  
    const object = {
      old_password:data.old_password,
      password:data.password,
      confirm_password: data.confirm_password,
    };
    dispatch({type: LOADED});
  
    try {
      const response = await api(localStorage.getItem("token")).patch("/user-management/user/password/update-self",{ ...object });
  
      if (response.status === 201) {
        
      dispatch({type: LOADED});
      dispatch({type: SUCCESS_MESSAGE,payload: "Your password is updated successfully"});
      return response.status
      }
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

  // ===========Registration verificatio=================
  
export const signupVerification = (token,user) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
      const obj = {
          token : token,
          user : user
      }
      const response = await api().patch('/signup/verify', {...obj});
      if(response.status === 201 ){
          
          if(user === 'true'){
              dispatch({ type: SUCCESS_MESSAGE, payload: "Verification successfull" });
              history.push('/login')}
          else{
              dispatch({ type: SUCCESS_MESSAGE, payload: "Your credential removed successfully" });
              history.push('/')
          }

          dispatch({type: LOADED})
      }
  }
  catch(err){
      if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        if(401 <= err?.response?.status  < 500 ){
        //if(err?.response?.status >= 401 &&  err?.response?.status  < 500 ){
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          else{
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            history.push('/registration')
            dispatch({type: LOADED});
            return
          }
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
  }
}


// ========== Unique ============
export const checkEmail = (email) => async (dispatch) => {
    try{
        const response = await api(localStorage.getItem("token")).get(`/unique?email=${email}`);
        
        if(response.status === 200 ){
            return response.data.unique
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}


// ========== Get verification email for reset Password ============
export const getEmail = (email) => async (dispatch) => {
    try{
        const response = await api(localStorage.getItem("token")).post(`/forgot/password`,
        {email: email});
        
        if(response.status === 201 ){
          dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
          dispatch({type: LOADED});
          return response.status
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}

// ========== Resend verification email for reset Password ============
export const resendEmail = (email) => async (dispatch) => {
    try{
        const response = await api(localStorage.getItem("token")).patch(`/resend`,
        {email: email,type: 'CLIENT-FORGOT-PASS'});
        
        if(response.status === 201 ){
          dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
          dispatch({type: LOADED});
          return response.status
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
          if(err?.response?.status === 404 ){
            history.push('/login')
          }
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}

  // ===========Password reset verificatio=================
  
  export const resetVerification = (token,user) => async (dispatch) => {
    dispatch({ type: LOADING });
    try{
        const obj = {
            token : token,
            user : user
        }
        const response = await api().patch('/forgot/password/token', {...obj});
        if(response.status === 201 ){
            if(user === 'true'){
                dispatch({ type: SUCCESS_MESSAGE, payload: "Verification successfull" });
                return response.data.public_token
                }
            else{
                dispatch({ type: SUCCESS_MESSAGE, payload: "Your credential removed successfully" });
                history.push('/login')
            }
  
            dispatch({type: LOADED})
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(401 <= err?.response?.status  < 500 ){
          //if(err?.response?.status >= 401 &&  err?.response?.status  < 500 ){
            if(err?.response?.status === 401 || err?.response?.status === 403 ){
                dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
                localStorage.clear();
                history.push('/login')
            }
            else{
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              history.push('/registration')
              dispatch({type: LOADED});
              return
            }
          }
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
  }
  
  export const resetPassword = (token,public_token,password,confirm_password) => async (dispatch) => {
    dispatch({ type: LOADING });
    try{
        const obj = {
            token : token,
            public_token : public_token,
            password : password,
            confirm_password: confirm_password,
        }
        const response = await api().patch('/forgot/password/confirm', {...obj});
        if(response.status === 201 ){
                dispatch({ type: SUCCESS_MESSAGE, payload: "Password reset successful" });
                history.push('/login')
            
  
            dispatch({type: LOADED})
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(401 <= err?.response?.status  < 500 ){
          //if(err?.response?.status >= 401 &&  err?.response?.status  < 500 ){
            if(err?.response?.status === 401 || err?.response?.status === 403 ){
                dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
                localStorage.clear();
                history.push('/login')
            }
            else{
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              // history.push('/registration')
              dispatch({type: LOADED});
              return
            }
          }
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
  }
  